export default {
  linkView: {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
};
